module.exports = "<tt-missing-working-days-notification></tt-missing-working-days-notification>\r\n<tt-on-call-notification></tt-on-call-notification>\r\n<tt-days-off-requests-notification></tt-days-off-requests-notification>\r\n<tt-working-time-notification></tt-working-time-notification>\r\n<tt-unapproved-days-off-requests-notification></tt-unapproved-days-off-requests-notification>\r\n<tt-unapproved-timecards-notification></tt-unapproved-timecards-notification>\r\n<tt-employee-unsubmitted-timecard-notification></tt-employee-unsubmitted-timecard-notification>"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/notifications/notifications.component.html
// module id = 479
// module chunks = 0